"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Drawer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _rcDrawer = _interopRequireDefault(require("rc-drawer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var styles = {
  "responsive": "lbc_2aa"
};

var Drawer = function Drawer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      placement = _ref.placement,
      isOpen = _ref.isOpen,
      trigger = _ref.trigger,
      drawerProps = _ref.drawerProps;

  var _React$useState = _react.default.useState(isOpen || false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isDrawerOpen = _React$useState2[0],
      setIsDrawerOpen = _React$useState2[1];

  var toggle = function toggle() {
    setIsDrawerOpen(!isDrawerOpen);
  };

  var close = function close() {
    setIsDrawerOpen(false);
  };

  var child = typeof children === 'function' ? _react.default.Children.only(children({
    close: close
  })) : _react.default.Children.only(children);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.cloneElement(trigger, {
    onClick: toggle
  }), _react.default.createElement(_rcDrawer.default, _extends({
    placement: placement,
    open: isDrawerOpen,
    onMaskClick: close,
    handler: false,
    level: null
  }, drawerProps), drawerProps.destroyOnClose && !isDrawerOpen ? null : child));
};

exports.Drawer = Drawer;
Drawer.propTypes = {
  //   className: PropTypes.string,
  //   isOpen: PropTypes.bool,
  placement: _propTypes.default.oneOf(['top', 'right', 'left', 'right']),
  trigger: _propTypes.default.element.isRequired //   maskable: PropTypes.bool,
  //   style: React.CSSProperties,
  //   maskStyle: React.CSSProperties,

};
Drawer.defaultProps = {
  //   className: '',
  //   isOpen: false,
  placement: 'right',
  drawerProps: {
    destroyOnClose: false
  } //   maskable: true,
  //   style: {},
  //   maskStyle: {},

};
var _default = Drawer;
exports.default = _default;